import './global';

export function checkContainer( newCurrentPage, containerPage ) {
	if ( newCurrentPage === containerPage ) {
		return 'active';
	} else {
		return '';
	}
}

export function updateUserInformation( info ) {
	return new Promise( ( resolve, reject ) => {
		let password_error = checkPassword( info.new_password, info.confirm_password );
		if ( password_error ) {
			resolve( password_error );
		} else {

			var params = {
				token: getToken(), newpwd: info.new_password
			};

			var data = {
				action      : 'wpAjaxJSONp',	// wp ajax action
				ajaxSSLNonce: wpAjaxJSONpVars.wpAJAXNonce, // nonce
				method      : 'pd_update_password', // server has switch/case for processing
				params      : params // data to be processed
			};

			jQuery.ajax( {
				             type       : 'GET', // this is the essence of jsonp
				             url        : wpAjaxJSONpVars.ajaxurl, // wp ajax url
				             cache      : false, // to ensure proper data response
				             dataType   : 'jsonp', // jsonp
				             crossDomain: true, // enable ssl/nonssl
				             data       : data, // data to be sent

				             success: function( response ) {
					             // your callback function

					             return true;
					             //			            callbackFunc(response);
				             },

				             complete: function( response ) {
					             resolve( response );
					             // console.log('complete', response);

				             },

				             error: function( response ) {
					             // console.log('error', response);
				             }
			             } );
		}
	} );

}

function filterResults( results ) {
	let newResults = results.filter( i => {
		return (i !== 'ALL' && i !== 'NA'
		);
	} );
	return newResults;
}

function handleInfo(info){

	info.job_title = (typeof info.job_title === 'undefined'
	                 ) ? getUserTitle() : info.job_title;
	info.department = (typeof info.department === 'undefined'
	                  ) ? getDepartment() : info.department;
	info.business_function = (typeof info.business_function === 'undefined'
	                         ) ? getBusinessFunction() : info.business_function;
	info.address_line_1 = (typeof info.address_line_1 === 'undefined'
	                      ) ? getAddress1() : info.address_line_1;
	info.address_line_2 = (typeof info.address_line_2 === 'undefined'
	                      ) ? getAddress2() : info.address_line_2;
	info.address_line_3 = (typeof info.address_line_3 === 'undefined'
	                      ) ? getAddress3() : info.address_line_3;
	info.city = (typeof info.city === 'undefined'
	            ) ? getCity() : info.city;
	info.state = (typeof info.state === 'undefined'
	             ) ? getStateCode() : info.state;
	info.postal_code = (typeof info.postal_code === 'undefined'
	                   ) ? getPostalCode() : info.postal_code;
	info.country = (typeof info.country === 'undefined'
	               ) ? getCountryCode() : info.country;
	info.state_name = (typeof info.state_name === 'undefined'
	                  ) ? getStateName() : info.state_name;
	info.phone_number = (typeof info.phone_number === 'undefined'
	                    ) ? getPhoneNumber() : info.phone_number;
	info.conference_agenda_topic = (typeof info.conference_agenda_topic === 'undefined'
	                               )
		? getConferenceAgendaTopic()
		: info.conference_agenda_topic;
	//if conference_Agenda_topic doesn't have OTR selected , we want to remove the value for the text editor.
	if ( Array.isArray( info.conference_agenda_topic ) ) {
		if ( info.conference_agenda_topic.includes( 'OTR' ) ) {
			info.conference_other_text = (typeof info.conference_other_text === 'undefined'
			                             )
				? getConferenceAgendaTopicOther()
				: info.conference_other_text;
		} else{
			info.conference_other_text = '';
		}
	} else{
		info.conference_other_text = '';
	}
	return info;
}

export function updateAdditionalInformation( info, token ) {
	return new Promise( ( resolve, reject ) => {

		info = handleInfo(info);
		let pd_address_line = [];
		pd_address_line[ 0 ] = info.address_line_1;
		pd_address_line[ 1 ] = info.address_line_2;
		pd_address_line[ 2 ] = info.address_line_3;
		var params = {
			job_title              : info.job_title,
			department             : info.department,
			business_function      : info.business_function,
			primary_interest       : filterResults( info.primary_interest ),
			policy_interest        : filterResults( info.policy_interest ),
			product_areas          : filterResults( info.product_areas ),
			otc_activity           : filterResults( info.otc_activity ),
			token                  : token,
			pd_address_line        : pd_address_line,
			pd_city                : info.city,
			pd_state               : info.state,
			pd_zip                 : info.postal_code,
			pd_country             : info.country,
			email                  : getEmail(),
			pd_state_name          : info.state_name,
			pd_phone               : info.phone_number,
			conference_agenda_topic: info.conference_agenda_topic,
			conference_other_text  : info.conference_other_text

		};

		var data = {
			action      : 'wpAjaxJSONp',	// wp ajax action
			ajaxSSLNonce: wpAjaxJSONpVars.wpAJAXNonce, // nonce
			method      : 'pd_update_information', // server has switch/case for processing
			params      : params // data to be processed
		};

		jQuery.ajax( {
			             type       : 'GET', // this is the essence of jsonp
			             url        : wpAjaxJSONpVars.ajaxurl, // wp ajax url
			             cache      : false, // to ensure proper data response
			             dataType   : 'jsonp', // jsonp
			             crossDomain: true, // enable ssl/nonssl
			             data       : data, // data to be sent

			             success: function( response ) {
				             // your callback function

				             return true;
				             //			            callbackFunc(response);
			             },

			             complete: function( response ) {
				             resolve( response );
				             // console.log('complete', response);

			             },

			             error: function( response ) {
				             // console.log('error', response);
			             }
		             } );
	} );

}

function checkPassword( new_password, confirm_password ) {
	const errorObj = {
		errors: {
			imis_password: []
		}
	};
	let errorMessage = '';
	if ( typeof new_password === 'undefined' || typeof confirm_password === 'undefined' ) {
		errorMessage = 'Please enter a new password to continue.';
		errorObj.errors.imis_password[ 0 ] = errorMessage;
		return errorObj;
	}
	if ( new_password.length < 7 ) {
		errorMessage = 'Password must be at least 7 characters long.';
		errorObj.errors.imis_password[ 0 ] = errorMessage;
		return errorObj;
	} else if ( new_password !== confirm_password ) {
		errorMessage = 'The passwords you entered do not match.';
		errorObj.errors.imis_password[ 0 ] = errorMessage;
		return errorObj;
	} else {
		return false;
	}
}
